import React from 'react';
import {Navigate, Outlet} from 'react-router-dom';
import {useKeycloak} from './useKeycloak';

export const PrivateRoute = () => {
    const {initialized, authenticated} = useKeycloak();

    if (!initialized) {
        return <div>
                    <h3 style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                        Aguarde...
                    </h3>
                </div>;
    }

    if (!authenticated) {
        return <Navigate to="/" replace />;
    }

    return <Outlet />;
};